/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_Storefront_Is_Live_AtInputs */

const en_your_storefront_is_live_at = /** @type {(inputs: Your_Storefront_Is_Live_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your storefront is live at`)
};

const es_your_storefront_is_live_at = /** @type {(inputs: Your_Storefront_Is_Live_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu tienda está activa en`)
};

const fr_your_storefront_is_live_at = /** @type {(inputs: Your_Storefront_Is_Live_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre vitrine est en ligne sur`)
};

const de_your_storefront_is_live_at = /** @type {(inputs: Your_Storefront_Is_Live_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Storefront ist live unter`)
};

const ja_your_storefront_is_live_at = /** @type {(inputs: Your_Storefront_Is_Live_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのストアフロントが公開されました：`)
};

const zh_your_storefront_is_live_at = /** @type {(inputs: Your_Storefront_Is_Live_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的店铺已上线，地址为`)
};

const ar_your_storefront_is_live_at = /** @type {(inputs: Your_Storefront_Is_Live_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهة متجرك متاحة الآن على`)
};

const id_your_storefront_is_live_at = /** @type {(inputs: Your_Storefront_Is_Live_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etalase Anda sedang live di`)
};

const it_your_storefront_is_live_at = /** @type {(inputs: Your_Storefront_Is_Live_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua vetrina è online all'indirizzo`)
};

const ru_your_storefront_is_live_at = /** @type {(inputs: Your_Storefront_Is_Live_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша витрина опубликована по адресу`)
};

const pt_your_storefront_is_live_at = /** @type {(inputs: Your_Storefront_Is_Live_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sua vitrine está online em`)
};

const ko_your_storefront_is_live_at = /** @type {(inputs: Your_Storefront_Is_Live_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`귀하의 스토어프론트가 다음 주소에서 라이브 중입니다:`)
};

/**
* | output |
* | --- |
* | "Your storefront is live at" |
*
* @param {Your_Storefront_Is_Live_AtInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_storefront_is_live_at = /** @type {((inputs?: Your_Storefront_Is_Live_AtInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Storefront_Is_Live_AtInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_storefront_is_live_at(inputs)
	if (locale === "es") return es_your_storefront_is_live_at(inputs)
	if (locale === "fr") return fr_your_storefront_is_live_at(inputs)
	if (locale === "de") return de_your_storefront_is_live_at(inputs)
	if (locale === "ja") return ja_your_storefront_is_live_at(inputs)
	if (locale === "zh") return zh_your_storefront_is_live_at(inputs)
	if (locale === "ar") return ar_your_storefront_is_live_at(inputs)
	if (locale === "id") return id_your_storefront_is_live_at(inputs)
	if (locale === "it") return it_your_storefront_is_live_at(inputs)
	if (locale === "ru") return ru_your_storefront_is_live_at(inputs)
	if (locale === "pt") return pt_your_storefront_is_live_at(inputs)
	return ko_your_storefront_is_live_at(inputs)
});